<template>
  <v-dialog persistent v-model="show" width="420">
    <v-card tile light :loading="loading">
      <v-system-bar>T-VSM</v-system-bar>
      <v-card-text class="mt-4" v-html="text"></v-card-text>
      <v-card-actions>
        <v-btn tile depressed 
          v-for="act in actions" :key="act.name"
          class="flex-grow-1" 
          :color="act.color"
          @click="modalActionHandler(act.name)">
          {{act.label}}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  methods: {
    modalActionHandler (name) {
      if (this.loading) return;
      this.$modal.$emit('modal-return', name, this)
    },
    open (opts) {
      if (!opts.text) return this.$modal.$emit('modal-return', 'error', this)
      this.text = opts.text
      this.actions = opts.actions || [{color: 'primary', name: 'close', label: '확인'}]
      this.show = true
    },
    close () {
      this.show = false
      this.text = ''
      this.loading = false
      this.actions = []
    }
  },
  mounted () {
    this.$modal.$on('modal-open', this.open.bind(this))
  },
  data () {
    return {
      show: false,
      loading: false,
      text: '',
      actions: []
    }
  }
}
</script>